// USA
export const locale = {
  validation: {
    required: 'This field is required.',
    email: 'Please enter a valid email address.',
    numeric: 'Please enter a valid number.',
    minLength: 'Please enter at least {min} characters.',
    maxLength: 'Please enter no more than {max} characters.',
    minValue: 'Please enter a value greater than or equal to {min}.',
    maxValue: 'Please enter a value less than or equal to {max}.',
    between: 'Please enter a value between {min} and {max}.',
    sameAs: 'Please enter the same value again.',
    countryCode: 'Please select country code.',
    uniqueEmail: 'Given email already exists.',
    uniquePhone: 'Given phone number already exists.',
    uniqueCardNumber: 'Given card number already exists.',
    isHour: 'Please enter in the correct format.',
    isPhone: 'Please enter a valid phone number.',
    integer: 'Please enter a valid integer.',
    threeChrForSearch: 'Type at least 3 characters for search.',
    needToConfirmPrivacyAndPolicy: 'You need to agree Privacy and Terms of Use',
  },
  common: {
    login: 'Login',
    email: 'Email',
    phone: 'Phone',
    save: 'Save',
    ok: 'OK',
    dontSave: "Don't Save",
    delete: 'Delete',
    restore: 'Restore',
    cancel: 'Cancel',
    close: 'Close',
    abort: 'Abort',
    done: 'Done',
    next: 'Next',
    prev: 'Previous',
    continue: 'Continue',
    status: 'Status',
    action: 'Action',
    address: 'Address',
    add: 'Add',
    drop: 'Drop',
    edit: 'Edit',
    description: 'Description',
    notes: 'Notes',
    note: 'Note',
    other: 'Other',
    active: 'Active',
    inactive: 'Inactive',
    reset: 'Reset',
    loading: 'Loading',
    load: 'Load',
    name: 'Name',
    account: 'Account',
    features: 'Features',
    history: 'History',
    support: 'Support',
    signOut: 'Sign Out',
    days: {
      Day: 'Day',
      days: 'Days',
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
    },
    permission: 'Permission',
    permissions: 'Permissions',
    start: 'Start',
    end: 'End',
    uploadPhoto: 'Upload Photo',
    session: 'Session',
    optional: '(Optional)',
    selectDuration: 'Select Duration',
    searchFilter: 'Search Filter',
    duration: 'Duration',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    firstName: 'First Name',
    lastName: 'Last Name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    birthDay: 'Birth Day',
    startDate: 'Start Date',
    endDate: 'End Date',
    startTime: 'Start Time',
    endTime: 'End Time',
    type: 'Type',
    date: 'Date',
    dueDate: 'Due Date',
    apply: 'Apply',
    treeSelectLimit: '{count} more',
    treeSelectNoOption: 'No options available.',
  },
  notification: {
    items: {
      book: 'Book',
      author: 'Author',
      category: 'Category',
      booking: 'Booking',
      comment: 'Comment',
      rating: 'Rating',
      wish: 'Wish',
      profile: 'Profile',
      password: 'Password',
      user: 'User',
      item: 'Item',
    },
    messages: {
      success: 'Successful!',
      error: 'Error!',
      createSuccess: '{item} created successfully.',
      createError: '{item} cannot created, an error occurred.',
      updateSuccess: '{item} updated successfully.',
      updateError: '{item} cannot updated, an error occurred.',
      deleteSuccess: '{item} deleted successfully.',
      deleteError: '{item} cannot deleted, an error occurred.',
      forbiddenSection: "You're not allowed to enter this section!",
      forbiddenAction: "You're not allowed to do this!",
      validationError: 'You must fill the inputs correctly!',
      wrongCredentials: 'Wrong email or password!',
      selectPaymentMethod: 'Please select a payment method!',
      loginNotAllowed: 'You have not login permission!',
      oldPasswordWrong: 'You entered old password wrong!',
      noSuchAUserHavingEmail: 'There is no user that has this email!',
      somethingWentWrong: 'Something went wrong!',
      borrowSuccessful: 'Book borrowing successfully!',
      addToWishSuccessful: 'Book added to wish list successfully!',
      returnSuccessful: 'Book returned successfully!',
      extensionSuccessful: 'Return date extended successfully!',
    },
    swal: {
      confirmDelete: 'Are you sure?',
      confirmDeleteDesc: "You won't be able to revert this!",
      saveChanges: 'Save changes?',
      saveChangesDesc:
        'Your unsaved changes will be lost! <br /> Save changes before closing?',
    },
  },
  project: {
    selectCategory: 'Select Category',
    searchBookName: 'Search Book Name',
    search: 'Search',
    title: 'Title',
    author: 'Author',
    authors: 'Authors',
    category: 'Category',
    categories: 'Categories',
    publisher: 'Publisher',
    publishDate: 'Publish Date',
    status: 'Status',
    transaction: 'Transaction',
    onTheShelf: 'On the Shelf',
    outOfTheShelf: 'Out of the Shelf',
    details: 'Details',
    comments: 'Comments',
    noComments: 'No Comments',
    rating: 'Rating',
    noRatings: 'No Ratings',
    book: 'Book',
    bookName: 'Book Name',
    books: 'Books',
    borrow: 'Borrow',
    borrowConfirm: 'Are you sure you want to borrow the book?',
    addToWishlist: 'Add to Wish List',
    member: 'Member',
    profileOverview: 'Profile Overview',
    changePassword: 'Change Password',
    canChangePassword: 'You can change your password',
    bookHistory: 'Book History',
    wishList: 'Wish List',
    wishListConfirm: 'Are you sure you want to add to Wish List the book?',
    wishListInfo: 'You can track books in your wish list',
    personalInformation: 'Personal Information',
    canUpdatePersonalInformation: 'You can update your personal information',
    saveChanges: 'Save Changes',
    confirm: 'Confirm',
    cancel: 'Cancel',
    avatar: 'Avatar',
    selectAvatar: 'Select Avatar',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    password: 'Password',
    reNewPassword: 'Re-new Password',
    bookHistoryInfo: 'You can see&return the books you have bought before',
    receivedDate: 'Received Date',
    returnedDate: 'Returned Date',
    borrowed: 'Borrowed',
    returned: 'Returned',
    extended: 'Extended',
    return: 'Return',
    returnConfirm: 'Are you sure you want to return the book?',
    extendConfirm: 'Are you sure you want to extend the return date?',
    comment: 'Comment',
    toComment: 'Comment',
    noRecord: 'There is no record',
    noNotification: 'You have no notifications',
    remove: 'Remove',
    removeConfirm: 'Are you sure you want to remove the book?',
    profile: 'Profile',
    library: 'Library',
    admin: 'Admin',
    administration: 'Administration',
    adminPanel: 'Admin Panel',
    users: 'Users',
    bookList: 'Book List',
    shelf: 'Shelf',
    barcode: 'Barcode',
    bookTransactions: 'Book Transactions',
    categoryTransactions: 'Category Transactions',
    authorTransactions: 'Author Transactions',
    adminTransactions: 'Admin Transactions',
    userTransactions: 'User Transactions',
    commentTransactions: 'Comment Transactions',
    description: 'Description',
    add: 'Add',
    addUser: 'Add User',
    addBook: 'Add Book',
    newAuthor: 'New Author',
    newCategory: 'NewCategory',
    edit: 'Edit',
    categoryList: 'Category List',
    addCategory: 'Add Category',
    categoryName: 'Category Name',
    authorList: 'Author List',
    addAuthor: 'Add Author',
    authorName: 'Author Name',
    adminList: 'Admin List',
    user: 'User',
    editor: 'Editor',
    userList: 'User List',
    role: 'Role',
    pendingComments: 'Pending Comments',
    approvedComments: 'Approved Comments',
    approve: 'Approve',
    myLibrary: 'My Library',
    aboutUs: 'About Us',
    contact: 'Contact',
    logOut: 'Log Out',
    notifications: 'Notifications',
    bookWaiting: 'Book is waiting for you!',
    bookRequest: 'Book Request',
    login: 'Login',
    loginFirst: 'You must login to borrow a book',
    selectBookWithNewSys1: 'You can select amazing books',
    selectBookWithNewSys2: 'with our new system',
    welcome: 'Welcome',
    areYouNew: 'Are you new?',
    createAnAccount: 'Create an account',
    forgetPassword: 'Did you forget password?',
    register: 'Register',
    enterDetailsToCreate: 'Enter your details to create your account',
    enterEmailToResetPassword:
      'Enter your email address to reset your password',
    send: 'Send',
    ok: 'Ok',
    messages: {
      emailRequired: 'Email is required!',
      emailValid: 'Please enter valid Email',
      passwordRequired: 'Password is required!',
      passwordsNotMatched: 'Passwords are not matched!',
      rePasswordRequired: 'Re-Password is required!',
      firstNameRequired: 'First Name is required!',
      lastNameRequired: 'Last Name is required!',
      sureToFillFields:
        'Please make sure you have filled the fields correctly. ',
    },
  },
};
